import React from 'react';
import { ShieldCheck, ArrowRight } from 'lucide-react';
import { Button } from '../ui/Button';
export function GuaranteeSection() {
  return <section className="py-20 bg-slate-50 border-t border-gray-200" data-id="element-22">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-23">
        <div className="max-w-3xl mx-auto text-center" data-id="element-24">
          <div className="inline-flex items-center justify-center p-4 bg-green-100 rounded-full mb-6" data-id="element-25">
            <ShieldCheck className="h-10 w-10 text-green-600" data-id="element-26" />
          </div>
          <h2 className="text-3xl font-bold text-gray-900 mb-4 font-serif" data-id="element-27">
            Garantía de Satisfacción Total
          </h2>
          <p className="text-lg text-gray-600 mb-8" data-id="element-28">
            Estamos tan seguros de que el Protocolo "Pies Sin Presión" cambiará
            tu vida que te ofrecemos una garantía de 30 días. Si no sentís
            alivio, te devolvemos el 100% de tu dinero. Sin preguntas.
          </p>
          <p className="text-sm text-gray-500 mb-8" data-id="element-29">
            Tu compra está protegida. Probá el sistema sin riesgo.
          </p>
          <a href="#oferta" data-id="element-30">
            <Button variant="cta" size="xl" className="group" data-id="element-31">
              Quiero Mi Kit Ahora
              <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" data-id="element-32" />
            </Button>
          </a>
        </div>
      </div>
    </section>;
}